import { connect } from 'react-redux';

const Search = ({ handleVoucherChange, voucherCode, checkValidVoucher }) => {
  return '';
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(mapDispatchToProps)(Search);
